import { Typography } from "@material-ui/core";
function FinalStage() {
  return (
    <>
      <Typography align="justify" variant="body1" component="p">
        Обращаем внимание, что принять участие в заключительном этапе
        многопрофильной олимпиады Вы можете <strong>только в одной</strong>{" "}
        профильной олимпиаде.
      </Typography>
      <Typography align="justify" variant="body1" component="p">
        Выберите олимпиаду и подтвердите свое участие в ее заключительном этапе.
      </Typography>
    </>
  );
}

export default FinalStage;
